import { createFileRoute, notFound, useLocation } from "@tanstack/react-router";
import contentStyles from "../styles/content.css?url";
import { ContentArticle } from "../components/content/content-article";
import { contentHead } from "../lib/content-head";
import { loadPostPreview } from "../server/previews";

/**
 * Customize's sample of a kind of post (/preview/post/:kind), for a kind the creator hasn't
 * published yet. Only the editor's preview reaches it.
 */
export const Route = createFileRoute("/preview/post/$kind")({
  loader: async ({ params }) => {
    const item = await loadPostPreview({ data: params.kind });
    if (!item) throw notFound();
    return item;
  },
  head: ({ matches, loaderData, match }) =>
    contentHead(matches, loaderData, match.pathname, contentStyles),
  component: PostPreview,
});

function PostPreview() {
  const item = Route.useLoaderData();
  const location = useLocation();
  return (
    <ContentArticle
      key={item.article.id}
      item={item}
      returnPath={location.pathname + location.searchStr}
    />
  );
}
